<template>
  <div>
    <div class="product-list__pagination">
      <div class="count">
        <span>Results: {{ results }} Rows</span>
        <page
          :total="results"
          @pageChange="pageChange"
          title="No. of Product Per Page"
          ref="page"
        ></page>
      </div>
    </div>
    <cc-table
      :dataArr="dataArr"
      :loadData="false"
      :config="configTable"
      :params="paramsTable"
      :refeshParams="refeshTable"
      indexFixed="left"
      :showIndex="false"
    >
      <!--  -->
    </cc-table>
  </div>
</template>

<script>
import page from "../../../components/page";

export default {
  components: {
    page,
  },
  props: {
    oerderData: {
      type: Object,
      default: 0,
    },
  },
  data() {
    return {
      //審核數據
      selectResultData: [],
      dataArr: [],
      results: 0,
      configTable: {
        // api: "admin/merchant/purchaseAudit/query?isAuditAsc=false",//
        showPager: false,
        indexFixed: "left",
        columns: [
          {
            minWidth: 120,
            lable: "Article Master",
            prop: "productNum",
          },
          {
            minWidth: 90,
            lable: "Barcode/ISBN",
            prop: "barcode",
          },
          {
            minWidth: 200,
            lable: "Product Name",
            prop: "productName",
          },
          {
            minWidth: 60,
            lable: "Count",
            prop: "num",
          },
        ],
        buttons: [],
      },
      paramsTable: {},
      refeshTable: -1,
      orderData: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    save() {
      this.selectResultData.forEach((v) => {
        v.opCount = v.num * 1;
      });
      console.log("this.selectResultData", this.selectResultData);
      var obj = { ...this.orderData };
      obj.deliverWarehousingDetails = this.selectResultData;
      this.$emit("change", obj);
    },
    selectingResult(e) {
      console.log("selectingResult111", e);
      this.selectResultData = [...e];
    },
    pageChange(e) {
      console.log("pageChange", e);
      console.log("this.totalData", this.totalData, e.pageNo * 10);
      var idx = 0

      if(e.pageNo!=1)idx = (e.pageNo - 1) * e.pageSize;
      
      console.log('idx',idx, (e.pageNo - 1) + e.pageSize*1);
      this.dataArr = this.totalData.slice(
       idx,
       (e.pageNo - 1) + e.pageSize*1
      );
      //   this.form.pageSize = e.pageSize;
      //   this.form.pageNo = e.pageNo;
      //   this.getData(this.form);
    },
    getData() {
      this.loading = false;
      var obj = { id: this.orderId };
      var res = { ...this.oerderData };

      console.log("res112", res);
      this.orderData = res;
      this.selectResultData = [];
      res.deliverWarehousingDetails.forEach((v) => {
        v.num = v.opCount + "";
      });

      this.results = res.deliverWarehousingDetails.length;
      this.totalData = res.deliverWarehousingDetails;
      this.dataArr = this.totalData.slice(0, 10);

      console.log("this.totalData", this.totalData);
      return;
      this.ccRequest
        .do("admin/merchant/warehousing/record/get", obj, "GET")
        .then((res) => {
          console.log("res112", res);
          this.orderData = res;
          this.selectResultData = [];
          res.deliverWarehousingDetails.forEach((v) => {
            v.num = v.opCount + "";
          });

          this.results = res.deliverWarehousingDetails.length;
          this.totalData = res.deliverWarehousingDetails;
          this.dataArr = this.totalData.slice(0, 10);

          console.log("this.totalData", this.totalData);
        })
        .catch((err) => {
          this.loading = true;
          this.$message.error(err.response.data.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  font-size: $sbuTitle;
  margin-bottom: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>